import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const businessCapacityEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() =>
			import(
				/* webpackChunkName: "async-business-capacity" */ './src/BusinessCapacityEntryPoint.tsx'
			),
	),
	getPreloadProps: (entryPointRouteParams: EntryPointRouteParams) => {
		const { tenantContext } = entryPointRouteParams;

		return {
			queries: {},
			entryPoints: {},
			extraProps: {
				tenantContext,
			},
		};
	},
});
